
import React, { Component } from "react";
import PageTitle from "../Components/Theme/PageTitle";
import DashboardLayout from "../Components/Theme/DashboardLayout";
import { Button, Col, Modal, Table, Row, message } from "antd";
import { InfoCard } from "../Components/Theme/Cards";
import { Link, Redirect } from 'react-router-dom';
import Spinner from '../Components/Theme/Spinner';
import moment from 'moment';
import { WrappedSelectLiveScheduleForm } from '../Components/Schedule/SelectLiveScheduleForm';
import { WrappedDetailedScheduleForm } from '../Components/Schedule/DetailedSchedule/DetailedScheduleForm';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from "redux";
import * as liveScheduleActions from '../redux/actions/liveScheduleActions';
import * as selectedResourceCollectionActions from '../redux/actions/selectedResourceCollectionActions';
import * as postedScheduleActions from '../redux/actions/postedScheduleActions';
import AuthLogic from '../AuthLogic';
import getOffsetTime from '../utils/getOffsetTime';


export class SchedulesPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            liveScheduleModal: false,
            liveScheduleSearch: false,
            liveSchedules: [],
            liveSchedulesTable: {
                columns: [
                    {
                        title: 'Live Schedules',
                        dataIndex: 'name',
                        render: text => <a>{text}</a>
                    }
                ],
                data: ''
            },
            selectedLiveSchedule: this.props.selectedLiveSchedule,
            scheduleDate: moment().startOf('day'), // api won't work unless start date is at beginning of day
            liveScheduleSubmitted: false,
            detailedScheduleModal: false,
            detailedStartDate: moment().startOf('day').subtract(7, 'days'),
            detailedEndDate: moment().endOf('day'),
            timeOffset: getOffsetTime(moment()),
            detailedScheduleSubmitted: false,
            showFilteredResources: false,
            filteredLiveSchedulesData: []
        };
        this.handleClick = this.handleClick.bind(this);
    }

    async componentDidMount() {
        try {
            if (!this.props.user) {
                return;
            }
            await this.props.actions.fetchListOfResourceCollection(this.props.user.login.id)
        } catch (error) {
            alert("Loading list of resource collections failed\n" + JSON.stringify(error));
            throw Error(error);
        }
        if (!localStorage.getItem('selectedLiveSchedule')) {
            this.props.actions.fetchFindResourceCollection();
        } else {
            const record = JSON.parse(localStorage.getItem('selectedLiveSchedule'));
            this.props.actions.updateResourceCollectionSelected(record);
            this.setState({ selectedLiveSchedule: record,})
        }

        // populate local liveSchedulesTable from schedules' list in redux
        const data = [];
        if (this.props.liveSchedules) {
            const liveSchedulesTable = this.state.liveSchedulesTable;
            for (let schedule of this.props.liveSchedules) {
                const row = {
                    key: schedule.id,
                    id: schedule.id,
                    name: schedule.name,
                };
                data.push(row);
            }
            liveSchedulesTable.data = data;
            this.setState({
                liveSchedulesTable
            });
        }
    }

    handleLiveScheduleSubmit = () => {
        if (this.state.selectedLiveSchedule.name && this.state.scheduleDate) {
            this.setState({
                liveScheduleSubmitted: true
            });
        } else {
            // alert("Attempted to submit without selecting a Schedule or Schedule Date");
        }
    };

    handleDetailedScheduleSubmit = () => {
        if (this.state.detailedStartDate && this.state.detailedEndDate) {
            this.setState({
                detailedScheduleSubmitted: true
            });
        } else {
            alert("Attempted to submit without choosing Start Date or End Date");
        }
    };

    showLiveModal = () => {
        this.setState({
            liveScheduleModal: true,
        });
    };


    showDetailedModal = () => {
        this.setState({
            detailedScheduleModal: true,
        });
    };

    handleLiveModalCancel = (e) => {
        this.setState({
            liveScheduleModal: false
        });
    };

    handleDetailedModalCancel = (e) => {
        this.setState({
            detailedScheduleModal: false
        });
    };

    handleLiveScheduleSearch = () => {
        if (this.state.liveScheduleSearch === false) {
            this.setState({
                liveScheduleSearch: true
            });
        } else {
            this.setState({
                liveScheduleSearch: false
            });
        }
    };

    handleLiveScheduleSelect = (record) => {
        this.setState({
            selectedLiveSchedule: record,
            liveScheduleSearch: false,
            showFilteredResources: false
        }, () => {
            localStorage.setItem('selectedLiveSchedule', JSON.stringify(this.state.selectedLiveSchedule));
        });
        this.props.actions.updateResourceCollectionSelected(record);
    };

    handleDateChange = date => {
        date = date.startOf('day'); // makes sure we're sending it the beginning of the day
        this.setState({
            scheduleDate: date || moment().startOf('day') // prevent null on field clear
        });
    };

    handleDetailedStartDateChange = date => {
        const prevDate = this.state.detailedStartDate;
        if (date && date.isAfter(moment())) {
            message.config({
                top: 24,
                duration: 2.5,
                maxCount: 5,
            });
            message.error('Start date cannot exceed the current time');
            date = null;
        }
        if (date && date.isAfter(moment(this.state.detailedEndDate))) {
            message.config({
                top: 24,
                duration: 2.5,
                maxCount: 5,
            });
            message.error('End date cannot precede the start date');
            date = null;
        }
        this.setState({
            detailedStartDate: date || prevDate
        });
    };

    handleDetailedEndDateChange = date => {
        const prevDate = this.state.detailedEndDate;
        if (date && date.isAfter(moment().endOf('day'))) {
            message.config({
                top: 24,
                duration: 2.5,
                maxCount: 5,
            });
            message.error('End date cannot exceed the current time');
            date = null;
        }
        if (date && date.isBefore(moment(this.state.detailedStartDate))) {
            message.config({
                top: 24,
                duration: 2.5,
                maxCount: 5,
            });
            message.error('End date cannot precede the start date');
            date = null;
        }
        this.setState({
            detailedEndDate: date || prevDate
        });
    };

    convertDateToDetailedFormat(date) {
        let newDate = date.replace(/-/g, '')
        newDate = newDate.substr(0, newDate.indexOf('T'));
        return newDate;
    }

    // In to disable redirects for sections that aren't in phase 1
    handleClick = e => {
        e.preventDefault();
    }

    handleSearchChange = async searchValue => {
        if (searchValue && searchValue !== '') {
            this.setState({ showFilteredResources: true });
        } else this.setState({ showFilteredResources: false });

        let filteredArray = [];

        if (this.state.liveSchedulesTable && this.state.liveSchedulesTable.data) {
          filteredArray = await this.state.liveSchedulesTable.data.filter((value) => {
              // QA - #1830 - Search box issue resolved --> some dummy accounts have null values in the array that comes back
            if (value && value.name && value.name.toLowerCase().includes(searchValue.toLowerCase())) {
                return value;
            }
            return null;
         });
        }

        this.setState({
            filteredLiveSchedulesData: filteredArray
        });
    }

    render() {

        if (this.props.user.securityLevels) {
            return (
                <DashboardLayout>
                    <PageTitle title={'View Schedules'}
                        subTitle={''} />


                    <Row gutter={32}>

                        {AuthLogic.postedSchedules(this.props.user) &&
                            (
                                <Col lg={8} md={24}>
                                    <Link to="/posted-schedules">
                                        <InfoCard value={'Posted Schedules'} /></Link>
                                </Col>
                            )
                        }


                        {AuthLogic.liveSchedules(this.props.user) &&
                            (
                                <Col lg={8} md={24}
                                    onMouseDown={this.showLiveModal}
                                >
                                    <Link to="#">
                                        <InfoCard value={'Live Schedules'} />
                                    </Link>

                                    <Modal
                                        visible={this.state.liveScheduleModal}
                                        title="Select Live Schedule"
                                        zIndex={2000}
                                        onCancel={this.handleLiveModalCancel}
                                        footer={[
                                            // <Button key="back" onClick={this.handleLiveModalCancel}>Cancel</Button>,
                                            // <Button key="submit" type="submit" onClick={this.handleLiveScheduleSubmit}>
                                            //     Submit
                                            // </Button>
                                        ]}
                                    >

                                        <WrappedSelectLiveScheduleForm
                                            handleLiveScheduleSearch={this.handleLiveScheduleSearch}
                                            liveScheduleSearch={this.state.liveScheduleSearch}
                                            searchValueStart={this.state.liveScheduleSearchEmpty}
                                            liveSchedules={this.props.liveSchedules}
                                            selectedLiveSchedule={this.state.selectedLiveSchedule}
                                            scheduleDate={this.state.scheduleDate}
                                            handleLiveDateChange={this.handleDateChange}
                                            returnSearchValue={this.handleSearchChange}
                                            handleLiveScheduleSubmit={this.handleLiveScheduleSubmit}
                                            columns={this.state.liveSchedulesTable.columns}
                                            dataSource={!this.state.showFilteredResources ?
                                                this.state.liveSchedulesTable.data :
                                                this.state.filteredLiveSchedulesData}
                                            handleLiveScheduleSelect={this.handleLiveScheduleSelect}
                                        />

                                    </Modal>
                                    {
                                        this.state.liveScheduleSubmitted && (
                                            <Redirect
                                                to={{
                                                    pathname: '/live-schedule-view-short',
                                                    state: {
                                                        startDate: this.state.scheduleDate,
                                                        scheduleFormat: 1,
                                                        resourceCollectionName: this.state.selectedLiveSchedule.name,
                                                        resourceCollectionId: this.state.selectedLiveSchedule.id,
                                                        editMode: this.editMode
                                                    }
                                                }}
                                            />
                                        )
                                    }
                                </Col>
                            )
                        }

                        {AuthLogic.assignments(this.props.user) &&
                            (
                                <Col lg={8} md={24}
                                    onMouseDown={this.showDetailedModal}
                                >
                                    <Link to="#" onClick={this.handleClick} >

                                        <InfoCard value={'Details for Tours/Assignments/Day Types'} />
                                    </Link>

                                    <Modal
                                        visible={this.state.detailedScheduleModal}
                                        title="Select dates for Detailed Schedule"
                                        zIndex={2000}
                                        onCancel={this.handleDetailedModalCancel}
                                        footer={[
                                            <Button key="back" onClick={this.handleDetailedModalCancel}>Cancel</Button>,
                                            <Button key="submit" type="submit" onClick={this.handleDetailedScheduleSubmit}>
                                                Submit
                                            </Button>
                                        ]}
                                    >
                                        <WrappedDetailedScheduleForm
                                            scheduleDate={this.state.scheduleDate}
                                            handleStartDateChange={this.handleDetailedStartDateChange}
                                            handleEndDateChange={this.handleDetailedEndDateChange}
                                            detailedStartDate={this.state.detailedStartDate}
                                            detailedEndDate={this.state.detailedEndDate}
                                        />
                                    </Modal>
                                    {
                                        this.state.detailedScheduleSubmitted && (
                                            <Redirect
                                                to={{
                                                    pathname: '/detailed-schedule-view',
                                                    state: {
                                                        schedule: this.state.selectedLiveSchedule,
                                                        detailedStartDate: this.convertDateToDetailedFormat(this.state.detailedStartDate.subtract(getOffsetTime(this.state.detailedStartDate), 'minutes').toISOString()),
                                                        detailedEndDate: this.convertDateToDetailedFormat(this.state.detailedEndDate.subtract(getOffsetTime(this.state.detailedStartDate), 'minutes').toISOString()),
                                                    }
                                                }}
                                            />
                                        )
                                    }
                                </Col>
                            )
                        }
                    </Row>

                </DashboardLayout>
            )
        } else return <Spinner />
    }
}

SchedulesPage.propTypes = {
    user: PropTypes.object.isRequired,
    liveSchedules: PropTypes.array
};

function mapStateToProps(state) {
    return {
        user: state.user,
        liveSchedules: state.listResourceCollections.resources,
        selectedLiveSchedule: state.selectedResourceCollection
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: {
            fetchListOfResourceCollection: bindActionCreators(
                liveScheduleActions.fetchListOfResourceCollection,
                dispatch
            ),
            fetchFindResourceCollection: bindActionCreators(
                selectedResourceCollectionActions.fetchFindResourceCollection,
                dispatch
            ),
            updateResourceCollectionSelected: bindActionCreators(
                selectedResourceCollectionActions.updateResourceCollectionSelected,
                dispatch
            ),
        }
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SchedulesPage);



// WEBPACK FOOTER //
// ./src/Pages/SchedulesPage.js